// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"36d63b09","239":"604f5f42","375":"2bc18ea4","453":"8ef94b35","457":"7f257a8d","629":"a2d4c77e","732":"6fdb6888","851":"61bc8298","977":"b2aeb4bf"}[chunkId] + ".chunk.js";
};